<template>
    <div class="row" :data-expand="isExpand ? true : null">
        <div class="cells"  v-on:click="toggleExpand()">
            <span class="cell" data-size="status" data-align="center">
                <span class="icon-status" :data-icon="histItem.userNm == 'System' ? 'system' : 'user'" :title="histItem.userNm == 'System' ? 'System' : 'User'">System</span>
            </span>
            <span class="cell" data-size="date">
                <time datetime="">{{convertUtcTimezoneToLocal(histItem.timeLine)}}</time>
            </span>
            <span class="cell" data-size="type">
                {{ $t('AUDIT.FILTER.SET_EVAL_ITEM')}}<!--차단목록-->
            </span>
            <span class="cell" data-size="user">
                {{histItem.userNm}}
            </span>
            <span class="cell"> 
                {{(histItem.histType == constants.HIST_TYPE.WHITELIST_CREATE || histItem.histType == constants.HIST_TYPE.INSPECTION_ADD )
                ? $t('AUDIT.LABEL.CASE.CREATE') : histItem.histType == constants.HIST_TYPE.RULE_DELETE ? $t('AUDIT.LABEL.CASE.DELETE'): histItem.histType == constants.HIST_TYPE.RULE_COPY? $t('AUDIT.LABEL.CASE.COPY'):''}}&nbsp;:&nbsp;<a href="#">
                    <!-- {{JSON.parse(histItem.evntLog)['enTitle']|| histItem.prgrSetNm }} -->
                    {{getAuditName(histItem)}}
                </a>
            </span>
            <span class="cell" data-align="center">
                <button type="button" class="buttons-icon" data-type="ghost" data-icon="expand" :data-expand="isExpand ? true : null">collapse / expand</button>
            </span>
        </div>

        <div v-if="histItem.histType != constants.HIST_TYPE.INSPECTION_ADD" class="expand-container">
            <div-loading v-if="isExpand && evntLog == null"></div-loading>
            <!-- inner tables -->
            <table class="tbl-inner" v-if="evntLog !== null">
                <caption>{{ $t('AUDIT.LABEL.CASE.CREATE_DELETE_BLOCK_LIST')}}</caption>
                <colgroup>
                    <col style="width: 185px;">
                </colgroup>
                <thead>
                <tr>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.ITEM')}}<!--항목--></th>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.DETAIL_CONTENTS')}}<!--상세 내용--></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <th>{{ $t('AUDIT.INSPECTION.NAME')}}<!--이름--></th>
                    <td>{{evntLog.titl}}</td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.INSPECTION.DESCRIPTION')}}<!--설명--></th>
                    <td>{{evntLog.desc}}</td>
                </tr>
                </tbody>
            </table>

        </div>
        <div v-if="histItem.histType == constants.HIST_TYPE.INSPECTION_ADD" class="expand-container">
            <div-loading v-if="isExpand && evntLog == null"></div-loading>
            <!-- inner tables -->
            <table class="tbl-inner" v-if="evntLog !== null">
                <caption>{{ $t('AUDIT.FILTER.CHANGE_ASSESSMENT_ITEM')}}</caption>
                <colgroup>
                    <col style="width: 185px;">
                </colgroup>
                <thead>
                <tr>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.ITEM')}}<!--항목--></th>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.DETAIL_CONTENTS')}}<!--상세 내용--></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    
                    <th>{{ $t('AUDIT.INSPECTION.NAME')}}<!--이름--></th>
                    
                    <td v-if="evntLog[$i18n.locale+'Title']!==null" v-for="plcyTitl of evntLog[$i18n.locale+'Title']">{{plcyTitl}}</td>
                    <td v-if="evntLog[$i18n.locale+'Title'] ==null" v-for="plcyTitl of evntLog.plcyTitl">{{plcyTitl}}</td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.INSPECTION.DESCRIPTION')}}<!--설명--></th>
                    <td v-if="evntLog[$i18n.locale+'Desc']!==null" v-for="plcyDesc of evntLog[$i18n.locale+'Desc']">{{plcyDesc}}</td>
                    <td v-if="evntLog[$i18n.locale+'Desc'] ==null" v-for="plcyDesc of evntLog.plcyDesc">{{plcyDesc}}</td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.INSPECTION.APPLIED_RULES')}}<!--적용된 규칙--></th>
                    <td>
                        <span v-if="evntLog[$i18n.locale+'RuleTitle']!==null" v-for="titl of evntLog[$i18n.locale+'RuleTitle']" class="item">{{titl}}</span>
                        <span v-if="evntLog[$i18n.locale+'RuleTitle'] ==null" v-for="titl of evntLog.ruleTitl" class="item">{{titl}}</span>
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.INSPECTION.AUTOMATIC_EVAL_SCHEDULE')}}<!--자동검사 스케줄--></th>
                    <td>
                        <span class="item" v-if="evntLog.execType == 'A' && evntLog.schdDt !== null"><time datetime="">{{evntLog.schdDt}}</time></span>
                        <span class="item">{{evntLog.rprtYn == 'Y' ? $t('AUDIT.INSPECTION.SEND_REPORT') : $t('AUDIT.INSPECTION.REPORT_NOT_RECEIVED')}} <!--(<time datetime="">yyyy-mm-dd 00:00:00 발송</time>)--></span>
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.INSPECTION.EVAL_SCOPE')}}<!--검사 범위--></th>
                    <td>
                        <span v-for="acc of evntLog.accId" class="item">{{acc}}</span>
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.INSPECTION.EVAL_REGION')}}<!--검사 범위--></th>
                    <td>
                        <span v-for="(region, idx) of evntLog.regionNm" class="item" :key="idx">{{region}}</span>
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.INSPECTION.WHITELIST')}}<!--화이트리스트--></th>
                    <td>
                        <span v-for="wTitl of evntLog.wtlTitl" class="item">{{wTitl}}</span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'ExpandInspectionCreate',
        props: ['histItem'],
        data: function() {
          return {
              evntLog: null,
              isExpand: false
          }
        },
        computed: {
            getLocale: function() {
                return this.$i18n.locale
            }
        },
        methods: {
            convertUtcTimezoneToLocal: function(date) {
                return date == null ? '-' : this.Common.convertUtcTimezoneToLocalByLang(date, this.getLocale)
            },
            toggleExpand: function(){
                this.isExpand = !this.isExpand
                this.isExpand && this.evntLog == null ? this.parseEvntLog() : false

            },
            parseEvntLog: function() {
                if(typeof(this.histItem.evntLog) !== 'undefined'){
                    this.evntLog =  JSON.parse(this.histItem.evntLog)
                    this.evntLog.titl = _.head(this.evntLog.titl);
                    this.evntLog.desc = _.head(this.evntLog.desc);
                }
            },
            getAuditName: function(hist){
                if (this.histItem.evntLog) {
                    var lang = JSON.parse(this.histItem.evntLog)[this.$i18n.locale+'Title'];
                    if (lang) {
                        return lang[0];
                    }
                }
                return  hist.prgrSetNm;
            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/audit/expand/inspectionCreate.vue